/**
 * cookie管理
 * 2022-03-03
 */

import Cookies from "js-cookie";

const domain = (() => {
  let hostname;
  if (typeof window === "undefined") {
    //server side
    hostname = process.env.NEXT_PUBLIC_host;
  } else {
    hostname = location.hostname;
  }
  return hostname.split(".").slice(-2).join(".");
})();

//主域上的cookie
// const domainKeyList = {
const keyList = {
  lang: "lang", //存储语言信息
  theme: "theme", //主题信息
  token: "token", //token
  clientCode: "clientCode", //唯一标识
  countryId: "countryId", //国家ID
};

export default {
  keyList,
  get(key, opt) {
    const itemKey = keyList[key];
    if (!itemKey)
      return console.log(
        "%c$cookie.get 键名不在列表内: %c" + key,
        "color: #ac2925",
        "color: red"
      );

    return Cookies.get(itemKey, {
      domain,
      ...(opt || {}),
    });
  },
  set(key, value, opt) {
    const itemKey = keyList[key];
    if (!itemKey)
      return console.log(
        "%c$cookie.set 键名不在列表内: %c" + key,
        "color: #ac2925",
        "color: red"
      );

    return Cookies.set(itemKey, value, {
      expires: 30,
      domain,
      ...(opt || {}),
    });
  }, //对象会被压成字符串
  remove(key, opt) {
    const itemKey = keyList[key];
    if (!itemKey)
      return console.log(
        "%c$cookie.remove 键名不在列表内: %c" + key,
        "color: #ac2925",
        "color: red"
      );

    return Cookies.remove(itemKey, {
      domain,
      ...(opt || {}),
    });
  },
  /*
  getDomain(key, opt) {
    const itemKey = domainKeyList[key];
    if (!itemKey)
      return console.log(
        "%c$cookie.get 键名不在列表内: %c" + key,
        "color: #ac2925",
        "color: red"
      );

    return Cookies.get(itemKey, {
      domain,
      ...(opt || {}),
    });
  },
  setDomain(key, value, opt) {
    const itemKey = domainKeyList[key];
    if (!itemKey)
      return console.log(
        "%c$cookie.set 键名不在列表内: %c" + key,
        "color: #ac2925",
        "color: red"
      );

    return Cookies.set(itemKey, value, {
      expires: 30,
      domain,
      ...(opt || {}),
    });
  },
  removeDomain(key, opt) {
    const itemKey = domainKeyList[key];
    if (!itemKey)
      return console.log(
        "%c$cookie.remove 键名不在列表内: %c" + key,
        "color: #ac2925",
        "color: red"
      );

    return Cookies.remove(itemKey, {
      domain,
      ...(opt || {}),
    });
  },
   */
};
